/** Wire ContactViewModel to POST /v1/contact via the bridge. */
export function bridgeContactSubmit(client, site) {
    return async (message) => {
        await client.submitContact({
            site,
            name: message.name,
            email: message.email,
            body: message.body,
        });
    };
}
//# sourceMappingURL=bridgeContactSubmit.js.map